import { api } from "@api";
import { useAppDispatch } from "@store";
import { collaborationApi } from "@/shared/services";

export const useHandleAuth = () => {
  const dispatch = useAppDispatch();
  // Liveblocks passes the room it is joining (undefined for inbox calls); the
  // backend scopes the token to that room at the caller's document role.
  const handleAuth = async (room?: string) => {
    const { token } = await collaborationApi.auth(room ? { room } : undefined);
    dispatch(api.util.invalidateTags([{ type: "Users", id: "CURRENT" }]));
    return { token };
  };

  return handleAuth;
};
